/**
 * Perioada saptamanala din ruta `/raport/$perioada`, in forma `2026-W34`.
 * Saptamanile din Excel („week 34") sunt ISO, deci se calculeaza cu `isoWeek`, nu cu `getWeek`
 * scris de mana — granitele de an sunt exact locul unde se greseste.
 */

import { isoWeek, todayInBucharest } from '@evomag/core/format';

export function perioadaImplicita(iso: string = todayInBucharest()): string {
  const { year, week } = isoWeek(iso);
  return `${year}-W${String(week).padStart(2, '0')}`;
}

/** `2026-W34` => `{ year: 2026, week: 34 }`, sau `null` daca forma nu se potriveste. */
export function parsePerioada(perioada: string): { year: number; week: number } | null {
  const m = /^(\d{4})-W(\d{2})$/.exec(perioada);
  if (!m) return null;
  const year = Number(m[1]);
  const week = Number(m[2]);
  if (week < 1 || week > 53) return null;
  return { year, week };
}
